import { FormEvent } from "react"
import { useForm, Link } from "@inertiajs/react"
import { AdminLayout } from "@/components/layouts/admin-layout"
import { MainContainer } from "@/components/ui/container"
import { PageHeader } from "@/components/ui/headers"
import { Card, CardContent } from "@/components/ui/card"
import { Alert, AlertDescription } from "@/components/ui/alert"
import { Button } from "@/components/ui/button"
import { Input } from "@/components/ui/input"
import { Label } from "@/components/ui/label"
import { t } from "@/lib/i18n"
type Props = {
    emailAddress: string
    errors?: string[]
}
export default function AdminUsersNew({ emailAddress, errors = [] }: Props) {
    const { data, setData, post, processing } = useForm({
        email_address: emailAddress ?? "",
    })
    const handleSubmit = (e: FormEvent) => {
        e.preventDefault()
        post("/users")
    }
    return (<AdminLayout>
      <MainContainer>
        <PageHeader title={t("ui.react.pages.admin.users.new.title")} description={t("ui.react.pages.admin.users.new.description")}/>
        <Card className="max-w-lg">
          <CardContent className="pt-6">
            <form onSubmit={handleSubmit} className="grid gap-6">
              {errors.length > 0 && (<Alert variant="destructive">
                  <AlertDescription>
                    <ul className="list-disc pl-4">
                      {errors.map((error) => (<li key={error}>{error}</li>))}
                    </ul>
                  </AlertDescription>
                </Alert>)}
              <div className="grid gap-2">
                <Label htmlFor="email_address">{t("ui.react.pages.admin.users.new.email")}</Label>
                <Input id="email_address" type="email" placeholder={t("ui.react.pages.admin.users.new.email_placeholder")} value={data.email_address} onChange={(e) => setData("email_address", e.target.value)} required/>
              </div>
              <div className="flex items-center justify-end gap-2">
                <Button type="button" variant="outline" asChild>
                  <Link href="/users">{t("ui.react.pages.admin.users.new.cancel")}</Link>
                </Button>
                <Button type="submit" disabled={processing}>{t("ui.react.pages.admin.users.new.create")}</Button>
              </div>
            </form>
          </CardContent>
        </Card>
      </MainContainer>
    </AdminLayout>)
}
